/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Undo_TitleInputs */



/**
* | output |
* | --- |
* | "Undo everything the agent changed for this prompt" |
*
* @param {Assistant_Activity_Undo_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_undo_title = /** @type {((inputs?: Assistant_Activity_Undo_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Undo_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler toutes les modifications apportées par l'agent pour cette invite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Machen Sie alle Änderungen rückgängig, die der Agent für diese Eingabeaufforderung vorgenommen hat.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla tutte le modifiche apportate dall'agente per questo prompt")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмените все изменения, внесенные агентом для этого запроса.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deshaga todos los cambios que el agente realizó para esta solicitud.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("撤销代理对此提示所做的所有更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロンプトに関してエージェントが変更したすべての変更を元に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस प्रॉम्प्ट के लिए एजेंट द्वारा किए गए सभी परिवर्तनों को पूर्ववत करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desfazer todas as alterações feitas pelo agente para este prompt")
	return /** @type {LocalizedString} */ ("Undo everything the agent changed for this prompt")
});